import { render, staticRenderFns } from "./VendorsStat.vue?vue&type=template&id=0d247c69&scoped=true"
import script from "./VendorsStat.vue?vue&type=script&lang=js"
export * from "./VendorsStat.vue?vue&type=script&lang=js"
import style0 from "./VendorsStat.vue?vue&type=style&index=0&id=0d247c69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d247c69",
  null
  
)

export default component.exports